var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"12","width":"12","height":"2","fill":"white","key":0}),React.createElement("rect",{"x":"4","y":"4","width":"4","height":"6","fill":"white","key":1}),React.createElement("path",{"d":"M6 0L9.4641 4.5H2.5359L6 0Z","fill":"white","key":2})]);
}

Upload.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none"};

module.exports = Upload;

Upload.default = Upload;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/upload.svg
// module id = 929
// module chunks = 0